import React, { useContext, useEffect, useState } from "react";
import LinkedList from "../../utils/LinkedList";
import { HomePadding } from "../HomePadding";
import SliderContext from "./context";

export default function Slider({ children, width = 1344, activeWidth = 924 }) {
  const { activeIndex, setActive, setCount } = useContext(SliderContext);

  useEffect(() => {
    setCount(children.length);
  }, []);

  const count = children.length;
  const inactiveWidth = (width - activeWidth) / (count - 1) - 1;

  const getLeft = (index) => {
    const extraSpace = index;
    if (index <= activeIndex) return `${index * inactiveWidth + extraSpace}px`;
    else return `${(index - 1) * inactiveWidth + activeWidth + extraSpace}px`;
  };

  const getWidth = (index) => {
    return index === activeIndex ? `${activeWidth}px` : `${inactiveWidth}px`;
  };

  const list = new LinkedList(count);

  return React.Children.map(children, (child, index) => {
    const item = list[index];

    return React.cloneElement(child, {
      onClick: () => setActive(item.index),
      onSwipedLeft: () => setActive(item.right.index),
      onSwipedRight: () => setActive(item.left.index),
      active: activeIndex === index,
      orientation: { left: getLeft(index) },
      width: getWidth(index),
    });
  });
}
